import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import swal from "sweetalert";
import { CartState } from "../context/Context";

export default function Contact() {
  const {
    state: { cart },
    dispatch,
  } = CartState();
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [message, setmessage] = useState("");
  const form = useRef();
  const nameInput = document.querySelector("#user_name");
  const emailInput = document.querySelector("#user_email");
  const textWrite = document.querySelector("textarea");

  const sendEmail = (e) => {
    e.preventDefault();
    if (Name.length === 0) {
      console.log("enter the text");
      swal({
        title: "Please Enter the Information",
        icon: "sucess",
        button: "Done",
      });
    } else {
      emailjs
        .sendForm(
          "service_q8qokoe",
          "template_vnl5iid",
          form.current,
          "b8ooaiL1mlIdQHc3K"
        )
        .then(
          (result) => {
            console.log(result.text);
            console.log(Name.length);
            console.log(Email.length);
            nameInput.value = "";
            emailInput.value = "";
            textWrite.value = "";

            swal({
              title: "Thank You",
              text: "We will contact you soon",
              icon: "success",
              button: "Done",
            });
          },
          (error) => {
            console.log(error.text);
          }
        );
    }
  };
  return (
    <>
      <div className="contact">
        <br />
        <h1 className="mt-0" style={{ textAlign: "center" }}>
          Contact Us
        </h1>
        <h5 className="mb-1" style={{ textAlign: "center" }}>
          Get in touch
        </h5>
        <div className="container5">
          <form
            className="form"
            data-aos="fade-up-right"
            data-aos-delay="100"
            ref={form}
            onSubmit={sendEmail}
          >
            <input
              className="input"
              onChange={(e) => setName(e.target.value)}
              type="text"
              id="user_name"
              name="user_name"
              placeholder="Name"
            />
            <input
              className="input"
              type="text"
              onChange={(e) => setEmail(e.target.value)}
              id="user_email"
              name="user_email"
              placeholder="E-Mail I.D."
            />
            <textarea
              name="message"
              className="textarea"
              onChange={(e) => setmessage([...e.target.value, cart])}
              id="textarea"
              placeholder="Enter message"
            ></textarea>
            <center>
              <button type="submit" className="button" value="Send">
                Submit
              </button>
            </center>
          </form>
          <div
            data-aos="zoom-in"
            data-aos-delay="100"
            className="container container4"
          >
            <iframe style={{width:"90%",height:"22rem",borderRadius:"1rem",boxShadow: "7px 14px 16px 2px #664646"}}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.2497074060598!2d77.18779657491766!3d28.652240975654006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d030ba0d9cb97%3A0x961e1c8d04780b51!2sSHRI%20SHYAM%20INTERIOR!5e0!3m2!1sen!2sin!4v1697186724947!5m2!1sen!2sin"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
}
